// react
import React, { Suspense } from 'react';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';
import { shallowEqual, useSelector } from 'react-redux';
import { useLastLocation } from 'react-router-last-location';
// helpers
import * as routerHelpers from './RouterHelpers';
// providers
import { LayoutSplashScreen, LayoutContextProvider } from '../../_metronic';
// layout
import Layout from '../layout/Layout.jsx';
// auth pages
import { AuthPage } from '../modules/Auth';
import ErrorsPage from '../modules/ErrorsExamples/ErrorsPage';
import LogoutPage from '../modules/Auth/pages/PageLogout';
// main pages
import Loans from '../pages/Loans.jsx';
import Commerce from '../pages/Commerce.jsx';
import CommerceSellers from '../pages/CommerceSellers.jsx';
import LoansRequests from '../pages/LoansRequests.jsx';
import LoansList from '../pages/LoansList.jsx';

export const Routes = withRouter(({ history }) => {
    const lastLocation = useLastLocation();

    routerHelpers.saveLastLocation(lastLocation);

    const { isAuthorized, menuConfig, userLastLocation } = useSelector(
        ({ auth, urls, builder: { menuConfig } }) => ({
            menuConfig,
            isAuthorized: auth.user != null,
            userLastLocation: routerHelpers.getLastLocation()
        }),
        shallowEqual
    );

    if (!isAuthorized) {
        return (
            <LayoutContextProvider history={history} menuConfig={menuConfig}>
                <Switch>
                    <AuthPage />
                    <Route path="/error" component={ErrorsPage} />
                    <Route path="/logout" component={LogoutPage} />
                    <Redirect to="/auth/login" />
                </Switch>
            </LayoutContextProvider>
        );
    }

    return (
        <LayoutContextProvider history={history} menuConfig={menuConfig}>
            <Switch>
                <Redirect from="/auth" to={userLastLocation} />
                <Route path="/error" component={ErrorsPage} />
                <Route path="/logout" component={LogoutPage} />
                <Layout>
                    <Suspense fallback={<LayoutSplashScreen />}>
                        <Switch>
                            <Redirect exact from='/' to='/dashboard' />
                            <Route path='/dashboard' component={Loans} />
                            <Route path='/:path/:id/sellers' component={CommerceSellers} />
                            <Route exact path='/commerce' component={Commerce} />
                            <Route exact path='/commerce-signs' component={LoansRequests} />
                            <Route exact path='/commerce-lists' component={LoansList} />
                        </Switch>
                    </Suspense>
                </Layout>
            </Switch>
        </LayoutContextProvider>
    );
});
